module.exports = __webpack_public_path__ + "assets/img/login-text.5fe315db.png";